import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './receitaForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import ReactExport from 'react-export-excel-fixed-xlsx';

import { setModoTela, initForm, salvar, excluir, getLista, setFiltro, alterarGeral } from './receitaActions';
import { getLista as getListaEmpresa } from '../empresa/empresaActions';
import { getLista as getListaCentroCusto } from '../centroCusto/centroCustoActions';
import { getLista as getListaAnalitica } from '../analitica/analiticaActions';
import { getLista as getListaFormaPagamento } from '../formaPagamento/formaPagamentoActions';
import { getLista as getListaDestinatario } from '../destinatario/destinatarioActions';

import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import Select from '../common/form/select';

class Receita extends Component {

	state = {
		linhaSelecionada: null,
		registroAlterar: {}
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaEmpresa();
		this.props.getListaCentroCusto();
		this.props.getListaAnalitica();
		this.props.getListaFormaPagamento();
		this.props.getListaDestinatario();
    }

	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setState({ ...this.state, modalAlteracao: null, registroAlterar: {} });
		}
	};

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	ordenar(lista) {
		
		const ordem = !this.props.filtro.ordenacao_ordem || this.props.filtro.ordenacao_ordem == 'crescente' ? 1 : -1;

		let listaAux = lista.map(item => ({ ...item }));

		listaAux.sort((a, b) => {
			if (!this.props.filtro.ordenacao_coluna || this.props.filtro.ordenacao_coluna == 'data_receita') {
				return (DateFormat.formatarDataSqlParaTela(a.data_receita) || '1') >= (DateFormat.formatarDataSqlParaTela(b.data_receita) || '1') ? ordem : ordem * -1;
			} else if (this.props.filtro.ordenacao_coluna == 'data_vencimento') {
				return (DateFormat.formatarDataSqlParaTela(a.data_vencimento) || '1') >= (DateFormat.formatarDataSqlParaTela(b.data_vencimento) || '1') ? ordem : ordem * -1;
			} else if (this.props.filtro.ordenacao_coluna == 'data_pagamento') {
				return (DateFormat.formatarDataSqlParaTela(a.data_pagamento) || '1') >= (DateFormat.formatarDataSqlParaTela(b.data_pagamento) || '1') ? ordem : ordem * -1;
			} else if (this.props.filtro.ordenacao_coluna == 'nome_fantasia_empresa') {
				return this.removerAcentos(a.nome_fantasia_empresa || '1') >= this.removerAcentos(b.nome_fantasia_empresa || '1') ? ordem : ordem * -1;
			} else if (this.props.filtro.ordenacao_coluna == 'nome_centro_custo') {
				return this.removerAcentos(a.nome_centro_custo || '1') >= this.removerAcentos(b.nome_centro_custo || '1') ? ordem : ordem * -1;
			} else if (this.props.filtro.ordenacao_coluna == 'nome_grupo') {
				return this.removerAcentos(a.nome_grupo || '1') >= this.removerAcentos(b.nome_grupo || '1') ? ordem : ordem * -1;
			} else if (this.props.filtro.ordenacao_coluna == 'nome_analitica') {
				return this.removerAcentos(a.nome_analitica || '1') >= this.removerAcentos(b.nome_analitica || '1') ? ordem : ordem * -1;
			} else if (this.props.filtro.ordenacao_coluna == 'nome_forma_pagamento') {
				return this.removerAcentos(a.nome_forma_pagamento || '1') >= this.removerAcentos(b.nome_forma_pagamento || '1') ? ordem : ordem * -1;
			} else if (this.props.filtro.ordenacao_coluna == 'nome_destinatario') {
				return this.removerAcentos(a.nome_destinatario || '1') >= this.removerAcentos(b.nome_destinatario || '1') ? ordem : ordem * -1;
			} else if (this.props.filtro.ordenacao_coluna == 'observacao') {
				return this.removerAcentos(a.observacao || '1') >= this.removerAcentos(b.observacao || '1') ? ordem : ordem * -1;
			} else if (this.props.filtro.ordenacao_coluna == 'valor') {
				return parseFloat(a.valor || 0) >= parseFloat(b.valor || 0) ? ordem : ordem * -1;
			}
		});

		return listaAux;
	}

	removerAcentos(str) {
		return str
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.replace(/ç/g, 'c')
			.replace(/Ç/g, 'C')
			.replace(/ñ/g, 'n') 
			.replace(/Ñ/g, 'N'); 
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = (this.props.lista).filter(item => {
			if (this.state.pesquisar
				&& !(`
					${DateFormat.formatarDataSqlParaTela(item.data_receita)}
					${DateFormat.formatarDataSqlParaTela(item.data_despesa)}
					${DateFormat.formatarDataSqlParaTela(item.data_pagamento)}
					${item.nome_fantasia_empresa}
					${item.nome_centro_custo}
					${item.nome_grupo}
					${item.nome_analitica}
					${item.nome_forma_pagamento}
					${item.nome_destinatario}
					${item.observacao}
					${FormatUtils.formatarValorTela(item.valor, 2)}
				`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}

			if (this.state.id_status == 1 && !item.data_pagamento) {
				return false;
			}

			if (this.state.id_status == 2 && item.data_pagamento) {
				return false;
			}

			if (this.props.filtro.preenchimento) {
				const completo = item.data_receita && item.id_empresa && item.id_centro_custo && item.id_analitica
					&& item.id_forma_pagamento && item.valor && item.id_destinatario
					&& item.data_vencimento

				if (this.props.filtro.preenchimento == 'completo' && !completo) {
					return false;
				} else if (this.props.filtro.preenchimento == 'incompleto' && completo) {
					return false;
				}
			}

			return true;
		});

		lista = this.ordenar(lista);

		let valorPago = 0;
		let valorAguardando = 0;

		return (
			<ContentCard>

				{this.modalAlteracao(lista)}

				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ data_receita: DateFormat.getDataAtual() });
								}} />
						</Grid>
						<Grid cols='6 6 3 2'>
							<ExcelFile
								filename={'Receitas'}
								element={
									<Button
									text='Exportar'
									type={'primary'}
									icon={'fa fa-plus'} />
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									data_receita: item.data_receita ? `${DateFormat.formatarDataSqlParaTela(item.data_receita)} 12:00` : null,
									data_vencimento: item.data_vencimento ? `${DateFormat.formatarDataSqlParaTela(item.data_vencimento)} 12:00` : null,
									data_pagamento: item.data_pagamento ? `${DateFormat.formatarDataSqlParaTela(item.data_pagamento)} 12:00` : null,
									valor: parseFloat(item.valor)
								}))} name='Despesas'>
									<ExcelColumn label='Registro' value='data_receita' />
									<ExcelColumn label='Vencimento' value='data_vencimento' />
									<ExcelColumn label='Pagamento' value='data_pagamento' />
									<ExcelColumn label='Empresa' value='nome_fantasia_empresa' />
									<ExcelColumn label='Centro Custo' value='nome_centro_custo' />
									<ExcelColumn label='Grupo' value='nome_grupo' />
									<ExcelColumn label='Analítica' value='nome_analitica' />
									<ExcelColumn label='Forma Pgto' value='nome_forma_pagamento' />
									<ExcelColumn label='Destino' value='nome_destinatario' />
									<ExcelColumn label='Observação' value='observacao' />
									<ExcelColumn label='Valor' value='valor' type='number' />
								</ExcelSheet>
							</ExcelFile>
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>

					<Row>						
						<LabelAndInputDate
							maxWidth={180}
							label='Período Inicial'
							cols='12 6 4 4'
							value={this.props.filtro.data_inicial}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data_inicial: value
								});
							}} />
						
						<LabelAndInputDate
							maxWidth={180}
							label='Período Final'
							cols='12 6 4 4'
							value={this.props.filtro.data_final}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data_final: value
								});
							}} />

						<Select
							maxWidth={250}
							options={[{ id: 1, valor: 'Recebida' }, { id: 2, valor: 'Não Recebida' }]}
							label='Status'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							value={this.props.filtro.id_status}
							onChange={value => {
								this.setState({
									...this.state,
									id_status: value
								});
							}} />

						<Select
							maxWidth={350}
							options={this.props.listaEmpresa}
							label='Empresa'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_empresa}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_empresa: values.map(item => item.value)
								});
							}} />
							
						<Select
							maxWidth={350}
							options={this.props.listaCentroCusto}
							label='Centro de Custo'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_centro_custo}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_centro_custo: values.map(item => item.value)
								});
							}} />
													
						<Select
							maxWidth={350}
							options={this.props.listaAnalitica}
							label='Analítica'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_analitica}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_analitica: values.map(item => item.value)
								});
							}} />
							
						<Select
							maxWidth={350}
							options={this.props.listaFormaPagamento}
							label='Forma de Pagamento'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_forma_pagamento}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_forma_pagamento: values.map(item => item.value)
								});
							}} />
							
						<Select
							maxWidth={350}
							options={this.props.listaDestinatario}
							label='Destino'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_destinatario}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_destinatario: values.map(item => item.value)
								});
							}} />
						
						<Select
							maxWidth={200}
							options={[{ id: 'completo', valor: 'Completo' }, { id: 'incompleto', valor: 'Incompleto' }]}
							label='Preenchimento'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							title={'Não considera os campos observação e data do pagamento'}
							value={this.props.filtro.preenchimento}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									preenchimento: value
								});
							}} />

						<a class='btn btn-app bg-primary'
							style={{ marginTop: 8 }}
							onClick={() => {
								this.props.getLista();
							}}>
							<i class='fas fa-sync-alt'></i> Atualizar
						</a>
					</Row>

					<Row>
						<Grid cols='12 4 5 7'>
							<label>Pesquisar</label>
							<input className='form-control'
								placeholder='Pesquisar'
								type='text'
								value={this.state.pesquisar}
								onChange={e => {
									this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
								}} />
						</Grid>
						<Select
							options={[{ id: 'crescente', valor: 'Crescente' }, { id: 'decrescente', valor: 'Decrescente' }]}
							label={'Ordenação'}
							cols='12 4 3 2'
							placeholder='Selecione'
							value={this.props.filtro.ordenacao_ordem}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									ordenacao_ordem: value
								});
							}} />
						<Select
							options={[
								{ id: 'data_receita', valor: 'Registro' },
								{ id: 'data_vencimento', valor: 'Vencimento' },
								{ id: 'data_pagamento', valor: 'Pagamento' },
								{ id: 'nome_fantasia_empresa', valor: 'Empresa' },
								{ id: 'nome_centro_custo', valor: 'Centro de Custo' },
								{ id: 'nome_grupo', valor: 'Grupo' },
								{ id: 'nome_analitica', valor: 'Analítica' },
								{ id: 'nome_forma_pagamento', valor: 'Forma Pgto' },
								{ id: 'nome_destinatario', valor: 'Destino' },
								{ id: 'observacao', valor: 'Observação' },
								{ id: 'valor', valor: 'Valor' }
							]}
							label={'Coluna'}
							cols='12 4 4 3'
							placeholder='Selecione'
							value={this.props.filtro.ordenacao_coluna}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									ordenacao_coluna: value
								});
							}} />
					</Row>

					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Registro</Th>
								<Th alignCenter>Vencimento</Th>
								<Th alignCenter>Pagamento</Th>
								<Th alignCenter>Empresa
									<i class='fas fa-pencil-alt' 
										style={{
											marginLeft: 4,
											color: '#444',
											cursor: 'pointer',
											transition: 'transform 0.2s ease, color 0.2s ease',
											transform: 'scale(1)'
										}}
										onClick={() => this.setState({ ...this.state, modalAlteracao: 'Empresa', registroAlterar: {} })} />
								</Th>
								<Th alignCenter>Centro de Custo
									<i class='fas fa-pencil-alt' 
										style={{
											marginLeft: 4,
											color: '#444',
											cursor: 'pointer',
											transition: 'transform 0.2s ease, color 0.2s ease',
											transform: 'scale(1)'
										}}
										onClick={() => this.setState({ ...this.state, modalAlteracao: 'Centro de Custo', registroAlterar: {} })} />
								</Th>
								<Th alignCenter>Grupo</Th>
								<Th alignCenter>Analítica 
									<i class='fas fa-pencil-alt' 
										style={{
											marginLeft: 4,
											color: '#444',
											cursor: 'pointer',
											transition: 'transform 0.2s ease, color 0.2s ease',
											transform: 'scale(1)'
										}}
										onClick={() => this.setState({ ...this.state, modalAlteracao: 'Analítica', registroAlterar: {} })} />
								</Th>
								<Th alignCenter>Forma Pgto</Th>
								<Th alignCenter>Destino</Th>
								<Th alignCenter>Observação</Th>
								<Th alignRight>Valor</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {
								
								if (item.data_pagamento) {
									valorPago += parseFloat(item.valor);
								} else {
									valorAguardando += parseFloat(item.valor);
								}

								return (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_receita)}</Td>
										<Td alignCenter small
											backgroundColor={item.data_pagamento ? null : (
												item.data_vencimento && DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_vencimento)) > DateFormat.getDataAtual() 
													? '#d4de1d' : '#b80000'
											)}
											color={item.data_pagamento ? null : (
												item.data_vencimento && DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_vencimento)) > DateFormat.getDataAtual() 
													? null : '#ffffff'
											)}>{DateFormat.formatarDataSqlParaTela(item.data_vencimento)}</Td>
										<Td alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_pagamento)}</Td>
										<Td alignCenter small>{item.nome_fantasia_empresa}</Td>
										<Td alignCenter small>{item.nome_centro_custo}</Td>
										<Td alignCenter small>{item.nome_grupo}</Td>
										<Td alignCenter small>{item.nome_analitica}</Td>
										<Td alignCenter small>{item.nome_forma_pagamento}</Td>
										<Td alignCenter small>{item.nome_destinatario}</Td>
										<Td alignCenter small noWrap>{item.observacao || ''}</Td>
										<Td alignRight small>{FormatUtils.formatarValorTela(item.valor, 2)}</Td>
										<Td alignRight minWidth={10}>																			
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.props.setModoTela('cadastro', {
														...item,
														valor: FormatUtils.formatarValorTela(item.valor, 2)
													});
													this.props.initForm({
														...item,
														valor: FormatUtils.formatarValorTela(item.valor, 2)
													});
												}} />

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.props.setModoTela('exclusao', {
														...item,
														valor: FormatUtils.formatarValorTela(item.valor, 2)
													});
													this.props.initForm({
														...item,
														valor: FormatUtils.formatarValorTela(item.valor, 2)
													});
												}} />
										</Td>
									</Tr>
								);
							})}

							<Tr>
								<Td colspan={9} bold alignRight>Total a Receber</Td>
								<Td colspan={2} bold alignRight>R$ {FormatUtils.formatarValorTela(valorAguardando, 2)}</Td>
								<Td bold alignRight minWidth={10}>																			
											
								</Td>
							</Tr>
							<Tr>
								<Td colspan={9} bold alignRight>Total Recebido</Td>
								<Td colspan={2} bold alignRight>R$ {FormatUtils.formatarValorTela(valorPago, 2)}</Td>
								<Td bold alignRight minWidth={10}>																			
											
								</Td>
							</Tr>
							<Tr>
								<Td colspan={9} bold alignRight>Total Geral</Td>
								<Td colspan={2} bold alignRight>R$ {FormatUtils.formatarValorTela(valorAguardando + valorPago, 2)}</Td>
								<Td bold alignRight minWidth={10}>																			
											
								</Td>
							</Tr>
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	modalAlteracao(lista) {

		if (!this.state.modalAlteracao) {
			return;
		}

        return (
			<>
				<div className="modal-backdrop fade show" />
				<div class='modal fade show' 
					id='modal-md' 
					style={{ display: 'block' }} 
					aria-modal='true'>
					<div class='modal-dialog modal-md'>
						<div class='modal-content'>
							<div class='modal-header' style={{ backgroundColor: '#556b2f', color: '#fff' }}>
								<h4 class='modal-title'>Alteração de {this.state.modalAlteracao}</h4>
								<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close' 
									onClick={() => this.setState({ ...this.state, modalAlteracao: null, registroAlterar: {} })}>
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 32, marginRight: 4 }}>×</span>
								</button>
							</div>
							<div class='modal-body'>

								<Row>
									<Grid cols='12 12 12 12'>
										<label style={{ }}>Selecione o item e clique em aplicar. Essa ação aplicará a mudança em todos os itens filtrados na lista.</label>
									</Grid>
								</Row>
								<Row style={{ marginTop: 12 }}>
									<Select
										options={
											this.state.modalAlteracao == 'Empresa' ? this.props.listaEmpresa : (
												this.state.modalAlteracao == 'Centro de Custo' ? this.props.listaCentroCusto : (
													this.state.modalAlteracao == 'Analítica' ? this.props.listaAnalitica : []
												)
											)
										}
										label={this.state.modalAlteracao}
										cols=' 12 12 12 12'
										placeholder='Selecione'
										value={
											this.state.modalAlteracao == 'Empresa' ? this.state.registroAlterar.id_empresa : (
												this.state.modalAlteracao == 'Centro de Custo' ? this.state.registroAlterar.id_centro_custo : (
													this.state.modalAlteracao == 'Analítica' ? this.state.registroAlterar.id_analitica : null
												)
											)
										}
										onChange={value => {
											if (this.state.modalAlteracao == 'Empresa') {
												this.setState({
													...this.state,
													registroAlterar: {
														...this.state.registroAlterar,
														id_empresa: value
													}
												});
											} else if (this.state.modalAlteracao == 'Centro de Custo') {
												this.setState({
													...this.state,
													registroAlterar: {
														...this.state.registroAlterar,
														id_centro_custo: value
													}
												});
											} else if (this.state.modalAlteracao == 'Analítica') {
												this.setState({
													...this.state,
													registroAlterar: {
														...this.state.registroAlterar,
														id_analitica: value
													}
												});
											}
										}} />
								</Row>

								<Row style={{ marginTop: 24, paddingRight: 8 }}>
									<Grid cols='6 6 6 6'>
										<Button
											text='Aplicar'
											type={'success'}
											icon={'fa fa-plus'}
											disabled={
												(this.state.modalAlteracao == 'Empresa' && !this.state.registroAlterar.id_empresa) 
												|| (this.state.modalAlteracao == 'Centro de Custo' && !this.state.registroAlterar.id_centro_custo)
												|| (this.state.modalAlteracao == 'Analítica' && !this.state.registroAlterar.id_analitica)
											}
											event={() => {
												if (
													(this.state.modalAlteracao == 'Empresa' && this.state.registroAlterar.id_empresa) 
													|| (this.state.modalAlteracao == 'Centro de Custo' && this.state.registroAlterar.id_centro_custo)
													|| (this.state.modalAlteracao == 'Analítica' && this.state.registroAlterar.id_analitica)
												) {
													this.props.alterarGeral(
														lista, 
														this.state.registroAlterar, 
														() => this.setState({ ...this.state, modalAlteracao: null, registroAlterar: {} })
													);
												}
											}} />
									</Grid>
									<Grid cols='6 6 6 6'>
										<Button
											text='Voltar'
											type={'warning'}
											icon={'fa fa-plus'}
											event={() => {
												this.setState({ ...this.state, modalAlteracao: null, registroAlterar: {} });
											}} />
									</Grid>
								</Row>
							</div>
						</div>
					</div>
				</div>
			</>
        );
    }
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.receita.modoTela,
	aguardando: state.receita.aguardando,
	lista: state.receita.lista,
	filtro: state.receita.filtro,
	listaEmpresa: state.empresa.listaSelect,
	listaCentroCusto: state.centroCusto.listaSelect,
	listaAnalitica: state.analitica.listaSelect,
	listaFormaPagamento: state.formaPagamento.listaSelect.filter(item => item.receita),
	listaDestinatario: state.destinatario.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, setFiltro, alterarGeral,
	getListaEmpresa, getListaCentroCusto, getListaAnalitica, getListaFormaPagamento, getListaDestinatario
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Receita);